<template>
    <div class="download-store-content flex items-center xl:flex-no-wrap lg:flex-wrap md:flex-wrap">
        <div class="left w-full xl:max-w-602px lg:max-w-none max-w-602px md:max-w-none flex-none xl:order-1 lg:order-2 order-1 md:order-2">
            <DownloadStoreLeft :img="phoneImg" />
        </div>
        <div class="right xl:pl-spc45 lg:pl-spc45 pl-spc45 md:px-spc2 xl:order-2 lg:order-1 order-2 md:order-1">
            <DownloadStoreRight />
        </div>
    </div>
</template>

<script>
    import DownloadStoreLeft from "./DownloadStoreLeft";
    import DownloadStoreRight from "./DownloadStoreRight";
    export default {
        name: "DownloadStore",
        components: {
            DownloadStoreRight,
            DownloadStoreLeft
        },
        data() {
            return {
                phoneImg: require('@/assets/images/phone.jpg'),
            }
        }
    }
</script>

<style scoped>

</style>